export default "/assets/images/mila-feed-14.95f3dcd3a5cad7d2.mp4";